const tools = require('form/tools')();
module.exports = function (language) {
  var validators = {
    get,
    minChars,
    maxChars,
    minDigits,
    minDigitsInMixedString,
    maxDigits,
    numberOfDigits,
    numberOfChars,
    regexp,
    maxNumberValue,
    minNumberValue,
    inbetweenDigits,
    choose,
    chooseMax,
    chooseUnless,
    minAge,
    minAgeFull,
    mandatory,
    mandatoryDropdown,
    mandatoryCheckbox,
    onlyDigits,
    notNumbers,
    matches,
    measuringPointId,
    trueOrError,
    minLength,
    maxLength,
    notInArray,
    notEquals,
    notEqualsOtherField,
    atleastOneEquals,
    onlyOneStartingZero,
    nationalIdentity,
    nationalIdentitySweeden,
    minLengthPhoneNumber,
    nativePhoneExactNumbers,
    organizationNumberSweeden,
    nationalIdentityDenmark,
    maxDecimals,
    minDigitsInString,
    minWords,
    errorIfSelected,
  };

  return validators;

  function organizationNumberSweeden() {
    const addDigit = (val) => {
      const valList = String(val).split('');
      if (valList.length > 1) {
        return valList.reduce((sum, value) => {
          sum += Number(value);
          return sum;
        }, 0);
      } else return Number(val);
    };
    const calcControllDigit = (valList) => {
      return valList.reduce((control, val, index) => {
        if (index % 2 === 0) control += addDigit(val * 2);
        else control += addDigit(val);
        return control;
      }, 0);
    };
    const validateNumbers = (valueList) => {
      const listLength = valueList.length;
      if (listLength !== 10 && listLength !== 12) return language['organization-identity-invalid'];
      else {
        const controlDigit = calcControllDigit(valueList);
        const validControllNumber = controlDigit % 10 === 0;
        return trueOrError(validControllNumber, language['organization-identity-invalid']);
      }
    };
    const validateInputValue = (value) => {
      return /^[1-9][0-9-]*$/.test(String(value));
    };

    return ({ value }) => {
      const correctFormat = validateInputValue(value);
      if (!correctFormat) return language['organization-identity-invalid'];
      else {
        const isNum = /[\d]/;
        const numberList = value.split('').filter((num) => isNum.test(num));
        return validateNumbers(numberList);
      }
    };
  }

  function minLengthPhoneNumber(number, error = language['error-min-x-numbers']) {
    const errorMessage = injectValuesIntoError(error, number);
    return ({ value }) => {
      const [plussStart, doubleZeroStart] = isInternationalFormat(value);
      const digits = getDigits(value);
      if (plussStart) return check(digits.length - 2);
      else if (doubleZeroStart) return check(digits.length - 4);
      else return check(digits.length);
    };
    function check(length) {
      if (length < number) return errorMessage;
      else return false;
    }
  }

  function nativePhoneExactNumbers(number, error = language['error-x-numbers']) {
    const errorMessage = injectValuesIntoError(error, number);
    return ({ value }) => {
      const [plussStart, doubleZeroStart] = isInternationalFormat(value);
      const digits = getDigits(value);
      if (plussStart) return false;
      else if (doubleZeroStart) false;
      else return check(digits.length);
    };

    function check(length) {
      return Number(length) === Number(number) ? false : errorMessage;
    }
  }

  function minDigitsInString(length, error = language['phone-invalid']) {
    return function minLength(state) {
      const digits = getDigits(state.value);
      return trueOrError(digits.length >= length, error);
    };
  }

  function getDigits(value) {
    return String(value).replace(/[^0-9]/g, '');
  }

  function isInternationalFormat(value) {
    const stringValue = String(value);
    return [stringValue.match(/^\+/), stringValue.match(/^00/)];
  }

  function nationalIdentity() {
    return ({ value }) => {
      if (validateIdentificationNumber(value)) return false;
      else return language['national-identity-invalid'];
    };
  }
  function nationalIdentitySweeden() {
    return ({ value }) => {
      if (validateIdentificationNumberSweeden(value)) return false;
      else return language['national-identity-invalid'];
    };
  }
  function nationalIdentityDenmark() {
    return ({ value }) => {
      if (validateCPRDenmark(value)) return false;
      else return language['national-identity-invalid'];
    };
  }

  function minDigitsInMixedString(number, error = language['error-min-x-numbers']) {
    const errorMessage = injectValuesIntoError(error, number);
    return ({ value }) => {
      const digits = String(value).replace(/[^0-9]/g, '');
      if (digits.length < number) return errorMessage;
      else return false;
    };
  }

  function measuringPointId() {
    return ({ value }) => {
      if (validateMeasuringPointId(value)) return false;
      else return language['measuring-id-invalid'];
    };
  }

  function onlyOneStartingZero() {
    return function ({ value }) {
      let number = Number(value);
      return trueOrError(value === String(number) || !value, 'Ikke gyldig');
    };
  }

  function get(key) {
    var [functionName, ...args] = key.split(':');
    return validators[functionName].bind(null, ...args);
  }

  function choose(number, error = language['error-choose']) {
    var errorMessage = injectValuesIntoError(error, number);
    return minLength(number, errorMessage);
  }

  function chooseMax(number, error = '--x-- for langt') {
    var errorMessage = injectValuesIntoError(error, number);
    return maxLength(number, errorMessage);
  }

  // Requires `number` selections unless the exempt option is selected.
  function chooseUnless(number, exemptValue, error = language['error-choose']) {
    var errorMessage = injectValuesIntoError(error, number);
    return function (state) {
      if (state.value.indexOf(exemptValue) !== -1) return false;
      else return trueOrError(state.value.length >= Number(number), errorMessage);
    };
  }

  function mandatoryCheckbox(error = 'Må avhukes') {
    return function (state) {
      if (state.value === 'false') return error;
      else return false;
    };
  }

  function onlyDigits(error = language['error-only-digits']) {
    return matches(/^[0-9]*$/, error);
  }

  // Validates minimum age using 6-digit birthdate (ddmmyy).
  function minAge(number, error = language['error-min-age']) {
    var errorMessage = injectValuesIntoError(error, number);
    return function (state, config) {
      var assumedAge = tools.ageFromDate(state.value);
      if (assumedAge >= number) return false;
      else return errorMessage;
    };
  }

  // Validates minimum age using 8-digit birthdate (ddmmyyyy).
  // Use this instead of minAge when the birthdate field uses full year format.
  // minAge uses 6-digit format (ddmmyy).
  function minAgeFull(number, error = language['error-min-age']) {
    var errorMessage = injectValuesIntoError(error, number);
    return function (state, config) {
      var assumedAge = tools.ageFromDateFull(state.value);
      if (assumedAge >= number) return false;
      else return errorMessage;
    };
  }

  function minChars(number, error = language['error-min-x-letters']) {
    var errorMessage = injectValuesIntoError(error, number);
    return minLength(number, errorMessage);
  }

  function maxChars(number, error = language['error-min-x-letters']) {
    var errorMessage = injectValuesIntoError(error, number);
    return maxLength(number, errorMessage);
  }

  function numberOfChars(number, error = language['error-x-letters']) {
    var errorMessage = injectValuesIntoError(error, number);
    return isLength(number, errorMessage);
  }

  function regexp(expression, error = 'Ugyldig verdi') {
    const errorMessage = logicalTrue(language[error], error);
    return matches(new RegExp(expression), errorMessage);

    function logicalTrue(val, fallback) {
      if (val === undefined || val === null || val !== val) return fallback;
      else return val;
    }
  }

  function numberOfDigits(number, error = language['error-x-numbers']) {
    var errorMessage = injectValuesIntoError(error, number);
    return [matches(/^[0-9]*$/, errorMessage), isLength(number, errorMessage)];
  }

  function minDigits(number, error = language['error-min-x-numbers']) {
    var errorMessage = injectValuesIntoError(error, number);
    return [matches(/^[0-9]*$/, errorMessage), minLength(number, errorMessage)];
  }

  function maxDigits(number, error = language['error-max-x-numbers']) {
    var errorMessage = injectValuesIntoError(error, number);
    return [matches(/^[0-9]*$/, errorMessage), maxLength(number, errorMessage)];
  }

  function inbetweenDigits(min, max, error = language['error-inbetween-numbers']) {
    var errorMessage = injectValuesIntoError(error, min, max);
    return [
      matches(/^[0-9]*$/, errorMessage),
      maxLength(max, errorMessage),
      minLength(min, errorMessage),
    ];
  }

  function injectValuesIntoError(errorMessage, ...values) {
    var variables = ['x', 'y', 'z'];

    return variables.reduce((replaced, variable, index) => {
      return (replaced || '').replace('--' + variable + '--', values[index] || '');
    }, errorMessage);
  }

  function maxNumberValue(maxValue, error = 'Verdien er høyere enn --x--') {
    var errorMessage = injectValuesIntoError(error, maxValue);
    return function (state) {
      if (Number(state.value) > maxValue) {
        return errorMessage;
      } else return false;
    };
  }

  function minNumberValue(minValue, error = 'Verdien er for lav') {
    var errorMessage = injectValuesIntoError(error, minValue);
    return function (state) {
      if (Number(state.value) < minValue) {
        return errorMessage;
      } else return false;
    };
  }

  function notInArray(value, error = 'Ugyldig valg: --x--') {
    var errorMessage = injectValuesIntoError(error, value);
    return function (state) {
      if (state.value.indexOf(value) !== -1) {
        return errorMessage;
      } else return false;
    };
  }

  function notEquals(value, error = 'Ugyldig verdi: --x--') {
    var errorMessage = injectValuesIntoError(error, value);
    return function (state) {
      if (String(state.value) === value) {
        return errorMessage;
      } else return false;
    };
  }

  function notEqualsOtherField(fieldName, error = 'Ugyldig verdi: --x--') {
    var errorMessage = injectValuesIntoError(error, fieldName);
    return function (state, _, globalState) {
      if (String(state.value).toLowerCase() === String(globalState[fieldName]).toLowerCase()) {
        return errorMessage;
      }
      return false;
    };
  }

  function atleastOneEquals(keys, words, error = 'Missing error message') {
    keys = keys.split(',');
    words = words.split(',');
    return function (state, _, globalState) {
      let shouldReturnError = true;
      keys.forEach((key) => {
        if (words.includes(globalState[key])) shouldReturnError = false;
      });
      return shouldReturnError ? error : false;
    };
  }

  function mandatory(error = language['error-mandatory']) {
    return minLength(1, error);
  }

  function mandatoryDropdown(error = language['error-mandatory']) {
    return function (state) {
      var invalids = [
        /--\s*velg\s*--/i,
        /--\s*välj\s*--/i,
        /--\s*vælg\s*--/i,
        /--\s*elige\s*--/i,
        /--\s*auswählen\s*--/i,
        /--\s*elige una opción\s*--/i,
        /--\s*seleziona\s*--/i,
        /--\s*Escolha uma opção\s*--/i,
        /--\s*Scegli un'opzione\s*--/i,
        /--\s*Scegliere un'opzione\s*--/i,
        /--\s*Choisissez parmi la liste\s*--/i,
        /--\s*Select\s*--/i,
      ];
      if (
        invalids.filter((regex) => {
          return String(state.value).match(regex);
        }).length !== 0
      ) {
        return error;
      } else return false;
    };
  }

  function notNumbers(error = language['name-invalid']) {
    return matches(/^[^0-9]*$/, error);
  }

  function matches(regexp, errorMessage, negative = false) {
    return function matches(state) {
      var match = String(state.value).match(regexp);
      return trueOrError(negative ? !match : match, errorMessage);
    };
  }

  function minLength(length, message) {
    return function minLength(state, config, globalState) {
      return trueOrError(state.value.length >= length, message);
    };
  }

  function isLength(length, message) {
    return function (state) {
      return trueOrError(state.value.length == length, message);
    };
  }

  function maxLength(length, message) {
    return function (state) {
      return trueOrError(state.value.length <= length, message);
    };
  }

  function trueOrError(isInputValid, errorMessage) {
    return isInputValid ? false : errorMessage;
  }

  function maxDecimals(length, message) {
    const countDecimals = (value) => {
      const valid = value.toString().split(/[,.]/).pop().split('%')[0];
      if (value % 1 != 0) return valid.length;
      return 0;
    };
    return function (state) {
      return trueOrError(countDecimals(state.value) <= length, message);
    };
  }
};

function validateIdentificationNumber(number) {
  var parts = [2, 2, 2, 3, 2].reduce(
    ({ remainingText, list }, length) => {
      return {
        remainingText: remainingText.slice(length),
        list: list.concat(remainingText.slice(0, length)),
      };
    },
    { remainingText: String(number), list: [] }
  ).list;

  return validateParts(parts);

  function validateParts(parts) {
    var [day, month, year, individualNumber, controlNumber] = parts;
    return [
      () => day >= 1 && day <= 31,
      () => month >= 1 && month <= 12,
      () => controlDigits(parts.join('')) === controlNumber,
    ].reduce((bool, f) => {
      return bool && f();
    }, true);
  }

  function controlDigits(identificationNumber) {
    return [
      [3, 7, 6, 1, 8, 9, 4, 5, 2],
      [5, 4, 3, 2, 7, 6, 5, 4, 3, 2],
    ]
      .map(controlDigit)
      .join('');

    function controlDigit(products) {
      var sum = products
        .map((product, index) => {
          return product * String(identificationNumber)[index];
        })
        .reduce((a, b) => a + b);
      var digit = 11 - (sum % 11);
      return digit === 11 ? 0 : digit;
    }
  }
}

function validateMeasuringPointId(value) {
  const stringValue = String(value);
  const [controll, ...rest] = stringValue.split('').reverse();
  const addedNumber = rest.reduce((result, number, index) => {
    if (index % 2 === 0) result += 3 * Number(number);
    else result += Number(number);
    return result;
  }, 0);
  const checkNumber = Math.ceil(addedNumber / 10) * 10 - addedNumber;
  const controlDigit = checkNumber % 10;
  return Number(controll) === Number(controlDigit);
}

function checkMonthNumbers(month) {
  return Number(month) < 13;
}

function checkDateNumbers(month, date) {
  switch (Number(month)) {
    case 1:
      return Number(date) < 32;
    case 2:
      return Number(date) < 30;
    case 3:
      return Number(date) < 32;
    case 4:
      return Number(date) < 31;
    case 5:
      return Number(date) < 32;
    case 6:
      return Number(date) < 31;
    case 7:
      return Number(date) < 32;
    case 8:
      return Number(date) < 32;
    case 9:
      return Number(date) < 31;
    case 10:
      return Number(date) < 32;
    case 11:
      return Number(date) < 31;
    case 12:
      return Number(date) < 32;
    default:
      return false;
  }
}

function validateIdentificationNumberSweeden(value) {
  let stringValue = String(value).replace('-', '');
  if (stringValue.length > 11) stringValue = stringValue.substring(2);
  const month = stringValue.substring(2, 4);
  const date = stringValue.substring(4, 6);
  const [controll, ...rest] = stringValue.split('').reverse();
  const addedNumber = rest.reduce((result, number, index) => {
    if (index % 2 === 0) result += combineDigits(2 * number);
    else result += combineDigits(number);
    return result;
  }, 0);
  const [ld, ..._] = String(addedNumber).split('').reverse();
  const [controlDigit, ...__] = String(10 - Number(ld))
    .split('')
    .reverse();

  return (
    Number(controll) === Number(controlDigit) &&
    checkMonthNumbers(month) &&
    checkDateNumbers(month, date)
  );

  function combineDigits(value) {
    const stringValue = String(value);
    if (stringValue.length === 1) return Number(value);
    else
      return stringValue.split('').reduce((result, num) => {
        result += Number(num);
        return result;
      }, 0);
  }
}

function validateCPRDenmark(value) {
  let stringValue = String(value).replace(/[- +.]/g, '');

  if (stringValue.length > 10) stringValue = stringValue.substring(2);

  const date = stringValue.substring(0, 2);
  const month = stringValue.substring(2, 4);

  return checkMonthNumbers(month) && checkDateNumbers(month, date) && stringValue.length === 10;
}

/**
 * @description checks for amount of words
 * @param {number} [minWords=2] - The minimum number of words to check for, defaults to 2
 * @param {string} errorMessage - The error message to return if the validation fails.
 */

function minWords(minWords = 2, errorMessage) {
  return function (state) {
    if (typeof state.value !== 'string' || state.value.trim().length === 0) {
      return errorMessage;
    }

    if (state.value.trim().split(/\s+/).length >= minWords) {
      return false;
    }
    return errorMessage;
  };
}

/**
 * @description Shows an error if a specific value is selected. (Birgit's function <3)
 * @param {string|number} forbiddenValue - The value that should trigger a validation error if selected.
 * @param {string} [errorMessage] - The error message to return if the forbidden value is selected.
 */

function errorIfSelected(forbiddenValue, errorMessage) {
  return function (state) {
    const value = state.value;

    if (Array.isArray(value)) {
      if (value.includes(forbiddenValue)) return errorMessage;
    } else {
      if (String(value) === String(forbiddenValue)) return errorMessage;
    }

    return false;
  };
}
